import { createAction } from 'redux-actions'
import * as types from './types'
import SystemServices from '../services/SystemService'

export const createPlace = place => (
  () => {
    SystemServices
      .createPlace(place)
      .then((data) => {
      })
      .catch((err) => {
        console.log(err)
      })
  }
)

export const fetchShipperPlaces = () => (
  (dispatch) => {
    SystemServices
      .fetchShipperPlaces()
      .then((result) => {
        dispatch(createAction(types.FETCH_SHIPPER_PLACES)(result))
      })
      .catch((err) => {
        // alert('erro palces' + JSON.stringify(err))
        console.log(err)
      })
  }
)

export const fetchAvailableCertificates = () => (
  (dispatch) => {
    SystemServices
      .fetchAvailableCertificates()
      .then((result) => {
        dispatch(createAction(types.FETCH_SHIPPER_AVAILABLE_CERTIFICATES)(
          result.map(item => ({ value: item.id, label: item.name, id: item.id }))))
      })
      .catch((err) => {
        // alert('erro palces' + JSON.stringify(err))
        console.log(err)
      })
  }
)

export const fetchAvailableRequirements = () => (
  (dispatch) => {
    SystemServices
      .fetchAvailableProperty()
      .then((result) => {
        dispatch(createAction(types.FETCH_SHIPPER_AVAILABLE_PROPERTY)(result))
      })
      .catch((err) => {
        // alert('erro palces' + JSON.stringify(err))
        console.log(err)
      })
  }
)


export const fetchIncidentCategories = () => (
  (dispatch) => {
    SystemServices
      .fetchIncidentCategories()
      .then((result) => {
        dispatch(createAction(types.FETCH_INCIDENT_CATEGORIES)(result))
      })
      .catch((err) => {
        // alert('erro palces' + JSON.stringify(err))
        console.log(err)
      })
  }
)
export const fetchOccurrenceTypesByShipperId = (shipperId) => (
  (dispatch) => {
    SystemServices
      .fetchOccurrenceTypesByShipperId(shipperId)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(createAction(types.FETCH_INCIDENT_CATEGORIES)(data))
        }
      })
      .catch((err) => {
        // alert('erro palces' + JSON.stringify(err))
        console.log(err)
      })
  }
)
